import React, { useState } from "react";
import { LoadingButton } from "../../../components/LoadingButton";
import { useTableContext } from "../../components/AdministrateTable";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { useUpdatePermission } from "../../utils";

export const CodeGroupCptCodeActionCell = ({ codeGroupId, ...row }) => {
  const [removing, setRemoving] = useState(false);
  const { refresh, setMessage, setError } = useTableContext();

  const [canUpdate] = useUpdatePermission("CodeGroup", codeGroupId);

  const handleRemoveCptCode = async () => {
    setRemoving(true);
    try {
      const { data } = await api.delete(`/admin/code_groups/${codeGroupId}/cpt_codes`, {
        params: { cpt_code_ids: [row.original.id] },
      });
      refresh();
      setMessage(data.meta?.message || `CPT Code ${row.original.code} removed from group.`);
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setRemoving(false);
    }
  };

  return (
    canUpdate && (
      <LoadingButton loading={removing} color="link" className="text-danger" onClick={handleRemoveCptCode}>
        Remove
      </LoadingButton>
    )
  );
};
